
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';

const App: React.FC = () => {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
